'use client';

import { c as _c } from "react/compiler-runtime";
import AppProvider from '@precis-digital/kurama/AppProviderNextjs';
import { type ReactElement, type ReactNode } from 'react';
import config from 'shared/config';
import { FEATURE_FLAGS, FeatureFlagProvider, useFeatureFlag } from 'shared/featureFlag';
import { LOCAL_STORAGE_KEYS } from 'shared/lstore';
const STATSIG_CLIENT_KEY = config('NEXT_PUBLIC_STATSIG_CLIENT_KEY') as string;

/**
 * TEMPORARY: bridges Statsig `light-dark-mode` → Kurama `AppProvider`.
 * Delete this file when the feature flag is removed; use `<AppProvider>` directly in BaseProviders.
 */
export const AlvieKuramaProvider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <FeatureFlagProvider platformKey={STATSIG_CLIENT_KEY}><AlvieKuramaProviderInner>{children}</AlvieKuramaProviderInner></FeatureFlagProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const AlvieKuramaProviderInner = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    value: isThemeSwitchingEnabled
  } = useFeatureFlag(FEATURE_FLAGS.lightDarkMode);
  let t1;
  if ($[0] !== children || $[1] !== isThemeSwitchingEnabled) {
    t1 = <AppProvider isThemeSwitchingEnabled={isThemeSwitchingEnabled} defaultThemePreference="system" themePreferenceStorageKey={LOCAL_STORAGE_KEYS.COLOUR_THEME_PREFERENCE}>{children}</AppProvider>;
    $[0] = children;
    $[1] = isThemeSwitchingEnabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};